export default class {
    constructor (id) {
        this._actions = []
        this._address = []
        this._basketLine = 0
        this._currency = 'EUR'
        this._deliveryMode = null
        this._fareExcludingTaxes = 0
        this._fareIncludingTaxes = 0
        this._id = id
        this._line = 0
        this._name = ''
        this._providerItemDescription = ''
        this._providerNetworkLabel = ''
        this._quantity = 1
        this._saleableUnit = 'UNIT'
        this._totalFareExcludingTaxes = 0
        this._totalFareIncludingTaxes = 0
        this._totalVatAmount = 0
        this._vatAmount = 0
        this._vatRate = 0
        this._version = 1
    }

    get address () {
        return this._address
    }

    set address (address) {
        this._address = address
    }

    get basketLine () {
        return this._basketLine
    }

    set basketLine (basketLine) {
        this._basketLine = basketLine
    }

    get currency () {
        return this._currency
    }

    set currency (currency) {
        this._currency = currency
    }

    get deliveryMode () {
        return this._deliveryMode
    }

    set deliveryMode (deliveryMode) {
        this._deliveryMode = deliveryMode
    }

    get fareExcludingTaxes () {
        return this._fareExcludingTaxes
    }

    set fareExcludingTaxes (fareExcludingTaxes) {
        this._fareExcludingTaxes = fareExcludingTaxes
    }

    get fareIncludingTaxes () {
        return this._fareIncludingTaxes
    }

    set fareIncludingTaxes (fareIncludingTaxes) {
        this._fareIncludingTaxes = fareIncludingTaxes
    }

    get id () {
        return this._id
    }

    set id (id) {
        this._id = id
    }

    get line () {
        return this._line
    }

    set line (line) {
        this._line = line
    }

    get name () {
        return this._name
    }

    set name (name) {
        this._name = name
    }

    get providerItemDescription () {
        return this._providerItemDescription
    }

    set providerItemDescription (providerItemDescription) {
        this._providerItemDescription = providerItemDescription
    }

    get providerNetworkLabel () {
        return this._providerNetworkLabel
    }

    set providerNetworkLabel (providerNetworkLabel) {
        this._providerNetworkLabel = providerNetworkLabel
    }

    get quantity () {
        return this._quantity
    }

    set quantity (quantity) {
        this._quantity = quantity
    }

    get saleableUnit () {
        return this._saleableUnit
    }

    set saleableUnit (saleableUnit) {
        this._saleableUnit = saleableUnit
    }

    get totalFareExcludingTaxes () {
        return this._totalFareExcludingTaxes
    }

    set totalFareExcludingTaxes (totalFareExcludingTaxes) {
        this._totalFareExcludingTaxes = totalFareExcludingTaxes
    }

    get totalFareIncludingTaxes () {
        return this._totalFareIncludingTaxes
    }

    set totalFareIncludingTaxes (totalFareIncludingTaxes) {
        this._totalFareIncludingTaxes = totalFareIncludingTaxes
    }

    get totalVatAmount () {
        return this._totalVatAmount
    }

    set totalVatAmount (totalVatAmount) {
        this._totalVatAmount = totalVatAmount
    }

    get vatAmount () {
        return this._vatAmount
    }

    set vatAmount (vatAmount) {
        this._vatAmount = vatAmount
    }

    get vatRate () {
        return this._vatRate
    }

    set vatRate (vatRate) {
        this._vatRate = vatRate
    }

    get version () {
        return this._version
    }

    set version (version) {
        this._version = version
    }

    get actions () {
        return this._actions
    }

    set actions (actions) {
        this._actions = actions
    }

    toJSON () {
        return {
            actions: this.actions,
            basketLine: this.basketLine,
            currency: this.currency,
            deliveryMode: this.deliveryMode,
            fareExcludingTaxes: this.fareExcludingTaxes,
            fareIncludingTaxes: this.fareIncludingTaxes,
            id: this.id,
            line: this.line,
            name: this.name,
            providerItemDescription: this.providerItemDescription,
            providerNetworkLabel: this.providerNetworkLabel,
            quantity: this.quantity,
            saleableUnit: this.saleableUnit,
            totalFareExcludingTaxes: this.totalFareExcludingTaxes,
            totalFareIncludingTaxes: this.totalFareIncludingTaxes,
            totalVatAmount: this.totalVatAmount,
            vatAmount: this.vatAmount,
            vatRate: this.vatRate,
            version: this.version
        }
    }
}
